import { Skeleton } from '@/components/ui/skeleton';
import { Switch } from '@/components/ui/switch';
import { Typography } from '@/components/ui/typography';

export interface SettingItemProps {
  title: React.ReactNode;
  description: React.ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export function SettingItem({
  title,
  description,
  checked,
  onCheckedChange,
  disabled = false,
  isLoading = false,
}: SettingItemProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-4">
        <Typography variant="body1" as="h3">
          {title}
        </Typography>
        {isLoading ? (
          <Skeleton className="h-4 w-8 shrink-0 !rounded-full" />
        ) : (
          <Switch
            checked={checked}
            onCheckedChange={onCheckedChange}
            disabled={disabled}
          />
        )}
      </div>
      <Typography variant="small1" className="!text-fx-neutral-600">
        {description}
      </Typography>
    </div>
  );
}
